import AppBar from '@mui/material/AppBar';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { userLogged } from 'common/selectors/user';
import { AppState, franchiseSelector } from 'common/store/store';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

interface MenuItemProps {
    caption: string;
    url: string | null;
    externalNavigation?: boolean;
}
const pages: MenuItemProps[] = [

];
const adminPages: MenuItemProps[] = [
    {
        caption: 'Admin',
        url: '/admin',
        externalNavigation: true
    }
];

export default () => {

    const user = useSelector((state: AppState) => userLogged(state));

    const navigate = useNavigate();
    const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
    const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
    const franchise = useSelector((state: AppState) => franchiseSelector.selectById(state, state.device.currFranchise));

    const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };


    return (
        <AppBar position="static">
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    <Box onClick={() => { navigate('/'); }} sx={{ pointer: 'cursor', height: 40, display: { xs: 'flex', md: 'flex' }, mr: 1 }} component='img' src="/images/PieuxProTechFondOrange.png" alt="Pieux Protech" />
                    {/*<AdbIcon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} />*/}
                    <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                        {/*<IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon />
                        </IconButton>
                        <Typography
                            variant="h6"
                            noWrap
                            component="a"
                            href="#app-bar-with-responsive-menu"
                            sx={{
                                mr: 2,
                                display: { xs: 'flex', md: 'none' },
                                fontWeight: 700,
                                color: 'inherit',
                                textDecoration: 'none',
                                lineHeight: '2.6'
                            }}
                        >
                            {franchise?.name ?? 'Pieux Protech'}
                        </Typography>*/}
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{ display: { xs: 'block', md: 'none' } }}
                        >
                            {/*(user ? adminPages : pages).map((page) => (
                                <MenuItem key={page.caption} onClick={() => {
                                    handleCloseNavMenu();
                                    if (page.url) {
                                        if (page.externalNavigation === true) {
                                            document.location.href = page.url;
                                        } else {
                                            navigate(page.url);
                                        }
                                    }
                                }}>
                                    <Typography sx={{ textAlign: 'center' }}>{page.caption}</Typography>
                                </MenuItem>
                            ))*/}
                        </Menu>
                    </Box>
                    {/*<Box onClick={() => { navigate('/'); }} sx={{ pointer: 'cursor', height: 40, display: { xs: 'flex', md: 'none' }, mr: 1 }} component='img' src="/PieuxProTechQuebecLevisBlanc.jpg" alt="Logo Pieux Protech Québec - Lévis" />*/}
                    {/*<AdbIcon sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }} />*/}
                    <Typography
                        variant="h5"
                        noWrap
                        component="a"
                        href="#app-bar-with-responsive-menu"
                        sx={{
                            mr: 2,
                            display: { xs: 'none', md: 'flex' },
                            flexGrow: 0,
                            fontWeight: 700,
                            color: 'inherit',
                            textDecoration: 'none',
                        }}
                    >
                        {franchise?.name ?? 'Pieux Protech'}
                    </Typography>
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                        {user ? <Button LinkComponent={'a'}
                            href="/admin"
                            sx={{ my: 2, color: 'white', display: 'block' }}
                        >
                            ADMIN
                        </Button> : null}
                        {/*(user ? adminPages : pages).map((page) => (
                            <Button
                                key={page.caption}
                                onClick={() => {
                                    handleCloseNavMenu();
                                    if (page.url) navigate(page.url);
                                }}
                                sx={{ my: 2, color: 'white', display: 'block' }}
                            >
                                {page.caption}
                            </Button>
                        ))*/}
                    </Box>
                    <Box sx={{ flexGrow: 0 }}>
                        {user ? <>
                            <Tooltip title="Ouvrir les options">
                                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                    <Avatar alt={user?.name ?? ''} />
                                </IconButton>
                            </Tooltip>
                            <Menu
                                sx={{ mt: '45px' }}
                                id="menu-appbar"
                                anchorEl={anchorElUser}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(anchorElUser)}
                                onClose={handleCloseUserMenu}
                            >
                                <MenuItem key={'admin'}>
                                    <Typography sx={{ textAlign: 'center' }}><a href={`/admin`}>Administration</a></Typography>
                                </MenuItem>
                                <MenuItem key={'logout'}>
                                    <Typography sx={{ textAlign: 'center' }}><a href={`/auth/logout`}>Se déconnecter</a></Typography>
                                </MenuItem>
                            </Menu>
                        </> : <Link to='/auth'>Connexion</Link>}
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
};
